<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="请输入名称进行搜索" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('nrgl_link_xz')">
            <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100" />
            <el-table-column label="名称" align="center" prop="name" />
            <el-table-column label="链接地址" align="center" prop="url" />
            <el-table-column v-if="permission('nrgl_link_bj') || permission('nrgl_link_sc')" label="操作" align="center" width="100">
                <template slot-scope="{ row }">
                    <el-button v-if="permission('nrgl_link_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                    <el-button v-if="permission('nrgl_link_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/content/link";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            del,
            list,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "链接",
            formPath: "/content/link/form",
        };
    },
    mounted() {
        this.search();
    },
    mixins: [listMixin],
    methods: {
        search() {
            this._search();
        },
        handleEdit(row) {
            this.$router.push({ path: this.formPath, query: { cuuid: row.cuuid } });
        },
    },
};
</script>
